import * as Sentry from '@sentry/react'
import { redirect } from 'react-router'

import { buildSessionState } from '@/contexts/auth/session/config'
import { queryClient } from '@/queries'
import { companiesQueryOptions } from '@/queries/companies'

export const sessionLoader = async (): Promise<null> => {
  const { isUserAuthenticated, userId } = buildSessionState()

  if (!isUserAuthenticated || !userId) {
    throw redirect('/login')
  }

  // Runs in parallel with userLoader: only set the id when it is missing or
  // stale, so the full profile set there is not overwritten.
  if (Sentry.getIsolationScope().getUser()?.id !== userId) {
    Sentry.setUser({ id: userId })
  }

  await queryClient.query({
    ...companiesQueryOptions(userId),
    staleTime: 'static',
  })

  return null
}
